import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { Link, useParams } from 'react-router-dom'
import { ApiStorage, ApiUrl } from '../../services/ApiRest';
import { FooterScreen } from '../footer/FooterScreen';
import { NavBarScreen } from '../navBar/NavBarScreen';
import { WhatsappButtonScreen } from './whatsappButton/WhatsappButtonScreen';
import { useGetDateToDayMonth } from '../../hooks/useGetDateToDayMonth';


export const MonthlyTourSingleScreen = () => {
    const { tourId } = useParams();
    console.log(tourId)

    const [tour, settour] = useState([]);
    const [travelers, setTravelers] = useState(1);
    const [cardTop, setCardTop] = useState('100vh');



    const getData = async () => {
        await axios.get(ApiUrl + "monthly-tour-show-id/" + tourId)
            .then(response => {
                const data = response.data;
                settour(data);
            }).catch(e => {
                console.log(e);
            })
    }

    useEffect(() => {
        getData();

    }, [])

    useEffect(() => {
        const handleScroll = () => {
            const scrollY = window.scrollY;
            if (scrollY > 400) {
                setCardTop('15vh');
            } else {
                setCardTop('100vh');
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const convertDate = (date) => {
        const { letterMonth, day } = useGetDateToDayMonth(date);
        var dateText = day + ' ' + 'DE ' + letterMonth;
        return (dateText);
    }


    return (
        <>
            <NavBarScreen var='.' />
            <br></br>
            <br></br>
            <br></br>
            <br></br>
            {console.log(tour)}
            <div className='container pantalla-grande'>
                <br></br>
                {tour.map((tour, index) => {
                    const price = travelers >= 4 ? tour.group_cost : tour.person_cost;
                    const total = price * travelers;
                    const message = `👋 ¡Hola! Me gustaría reservar *${travelers} cupos* para el tour a *${tour.tour_destiny}* 🥾🏔️\n\n*Fecha de salida:* ${tour.departure_date}.\n*Costo total del Tour:* $${total}\n*Valor para reservar el tour:* $${total/2} \n\n¿Podrías confirmarme si la información es correcta? ¡Gracias! 🙌`;

                    return (<>
                        <div className='row' key={index}>

                            <div className='col-12 col-sm-12 col-md-7'>
                                <div
                                    id="carouselExampleControls2"
                                    className="carousel slide shadow rounded overflow-hidden"
                                    data-bs-ride="carousel"
                                    style={{ height: '65vh' }} // Altura fija del carousel
                                >
                                    <div className="carousel-inner h-100">
                                        <div className="carousel-item active h-100">
                                            <img
                                                src={`${ApiStorage + tour.img_1}`}
                                                className="d-block w-100 h-100"
                                                alt="..."
                                                style={{ objectFit: 'cover' }}
                                            />
                                        </div>
                                        <div className="carousel-item h-100">
                                            <img
                                                src={`${ApiStorage + tour.img_2}`}
                                                className="d-block w-100 h-100"
                                                alt="..."
                                                style={{ objectFit: 'cover' }}
                                            />
                                        </div>
                                    </div>

                                    <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleControls2" data-bs-slide="prev">
                                        <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                                        <span className="visually-hidden">Previous</span>
                                    </button>

                                    <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleControls2" data-bs-slide="next">
                                        <span className="carousel-control-next-icon" aria-hidden="true"></span>
                                        <span className="visually-hidden">Next</span>
                                    </button>
                                </div>
                            </div>


                            <div className='col-12 col-sm-12 col-md-5'>
                                <br></br>

                                <h1 className='camping-letters fw-bold text-uppercase mb-1'>{tour.tour_destiny}</h1>
                                <h5 className='text-muted fst-italic'>{tour.tour_name}</h5>


                                <ul className="list-unstyled">
                                    <li><strong>Tipo de Ruta:</strong> {tour.type}</li>
                                    <li><strong>Dificultad:</strong> {tour.dificulty}</li>
                                    <li><strong>Costo por Persona:</strong> ${tour.person_cost}</li>
                                    <li><strong>Costo por Grupo (4+):</strong> ${tour.group_cost}</li>
                                </ul>

                                <div className='bg-white shadow-sm p-3 rounded mt-3 text-center'>

                                    <div className='row text-center'>
                                        <div className='col-12 col-sm-6'>
                                            <h4 className='camping-letters' style={{ textTransform: 'uppercase' }}>Salida<br></br> </h4>
                                            <h5>{convertDate(tour.departure_date)}</h5>
                                        </div>
                                        <div className='col-12 col-sm-6'>
                                            <h4 className='camping-letters' style={{ textTransform: 'uppercase' }}>Retorno <br></br> </h4>
                                            <h5>{convertDate(tour.return_date)}</h5>

                                        </div>
                                    </div>

                                    <br></br>
                                    <a href={`https://api.whatsapp.com/send?phone=+593${tour.contact_phone}&text=${tour.messagge_for_contact}`} target="_blank" rel="noopener noreferrer">
                                        <button className="btn btn-success me-2 mb-2">COMPRAR RUTA</button>
                                    </a>
                                    <Link to="/tour-mensual">
                                        <button className="btn btn-outline-secondary mb-2">VOLVER A TOURS</button>
                                    </Link>
                                </div>



                            </div>

                            <div
                                className='bg-white p-4 shadow rounded position-fixed d-none d-md-block'
                                style={{ top: cardTop, right: '6vw', width: '300px', zIndex: 1050 }}
                            >
                                <h4 className='mb-3 text-center camping-letters'>Reserva tu lugar</h4>
                                <div className='d-flex justify-content-between align-items-center mb-2'>
                                    <span>Cantidad de viajeros:</span>
                                    <div>
                                        <button className='btn btn-outline-secondary btn-sm me-2' onClick={() => setTravelers(Math.max(1, travelers - 1))}>-</button>
                                        <strong>{travelers}</strong>
                                        <button className='btn btn-outline-secondary btn-sm ms-2' onClick={() => setTravelers(travelers + 1)}>+</button>
                                    </div>
                                </div>
                                <p className='text-center fw-bold'>Total: ${total}</p>
                                {/* <small className='text-muted text-center' style={{ lineHeight: '1 !important', textAlign:'Center' }}>Reserva con: ${total/2} </small> */}
                                <div className='text-center'>
                                    <a
                                        href={`https://api.whatsapp.com/send?phone=+593${tour.contact_phone}&text=${encodeURIComponent(message)}`}
                                        target='_blank'
                                        rel='noopener noreferrer'
                                    >
                                        <button className='btn btn-success w-100 mb-2'>COMPRAR RUTA</button>
                                    </a>
                                    <Link to='/tour-mensual'>
                                        <button className='btn btn-outline-secondary w-100'>VOLVER A TOURS</button>
                                    </Link>
                                </div>
                            </div>






                        </div>

                        <div className='row'>
                            {/* <div className='col-12 mt-5'>
                                <section className="bg-light p-4 rounded shadow-sm my-4">
                                    
                                </section>


                                <section className="mt-4 p-4 rounded shadow-sm" style={{ backgroundColor: '#f9f9f9' }}>
                                   
                                </section>
                            </div> */}

                            <div className='col-12 col-md-9 bg-light p-4 rounded shadow-sm my-4'>
                                <h3 className='camping-letters text-center mb-3'>
                                    📅 Itinerario
                                </h3>
                                <div className='preserve-whitespace' dangerouslySetInnerHTML={{ __html: tour.description }} />
                            </div>

                            <div className='col-12 col-md-9 bg-light p-4 rounded shadow-sm my-4'>
                                <h3 className='camping-letters text-center mb-3'>
                                    Incluye
                                </h3>
                                <div className='text-justify preserve-whitespace' dangerouslySetInnerHTML={{ __html: tour.include }} />
                            </div>
                        </div>
                    </>

                    );
                })}
            </div>


            {/* *********PANTALLA PEQUE************* */}

            <div className='container pantalla-peque'>
                <br></br>
                {tour.map((tour, index) => (
                    <div className=' row' key={tour.tour_catalogues_id} >
                        <h1 className='camping-letters text-center' style={{ textTransform: 'uppercase' }}> {tour.tour_destiny}</h1>
                        <h5 className='camping-letters text-center'> {tour.tour_name}</h5>

                        <div className='col-12 col-sm-12 col-md-6'>
                            <div id="carouselExampleControls3" className="carousel slide" data-bs-ride="carousel">
                                <div className="carousel-inner">
                                    <div className="carousel-item carousel-item2 active">
                                        <img src={`${ApiStorage + tour.img_1}`} style={{ width: '100%' }} className="card-img-top" alt="..."></img>
                                    </div>
                                    <div className="carousel-item carousel-item2 ">
                                        <img src={`${ApiStorage + tour.img_2}`} style={{ width: '100%' }} className="card-img-top" alt="..."></img>
                                    </div>
                                </div>
                                <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleControls3" data-bs-slide="prev">
                                    <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                                    <span className="visually-hidden">Previous</span>
                                </button>
                                <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleControls3" data-bs-slide="next">
                                    <span className="carousel-control-next-icon" aria-hidden="true"></span>
                                    <span className="visually-hidden">Next</span>
                                </button>
                            </div>
                        </div>
                        <div className='col-12 col-sm-12 col-md-6'>
                            <br></br>
                            <div>

                            </div>

                            {/* <p className='text-justify'>{tour.description}</p> */}

                            {/* <p className='text-justify'><b>Incluye:</b> {tour.include}</p> */}
                            <ul className="list-unstyled">
                                <li><strong>Tipo de Ruta:</strong> {tour.type}</li>
                                <li><strong>Dificultad:</strong> {tour.dificulty}</li>
                                <li><strong>Costo por Persona:</strong> ${tour.person_cost}</li>
                                <li><strong>Costo por Grupo (4+):</strong> ${tour.group_cost}</li>
                                <li><strong>Punto de encuentro:</strong> {tour.meeting_point}</li>
                            </ul>
                            <br></br>

                            <div className='row text-center'>
                                <div className='col-12 col-sm-6'>
                                    <h4 className='camping-letters' style={{ textTransform: 'uppercase' }}>Fecha Salida<br></br> </h4>
                                    <h5>{convertDate(tour.departure_date)}</h5>
                                </div>
                                <div className='col-12 col-sm-6'>
                                    <h4 className='camping-letters' style={{ textTransform: 'uppercase' }}>Fecha Retorno <br></br> </h4>
                                    <h5>{convertDate(tour.return_date)}</h5>
                                </div>
                            </div>

                            <br></br>
                            <div className='container text-center'>
                                <a href={`https://api.whatsapp.com/send?phone=+593${tour.contact_phone}&text=${tour.messagge_for_contact}`} target="_blank" style={{ padding: '5px' }}>
                                    <button type="button" className="btn btn-success" style={{ margin: '2vh' }}> COMPRAR  RUTA </button >
                                </a>

                                <Link to={'/tour-mensual'} style={{ padding: '5px' }}>
                                    <button type="button" className="btn btn-warning" >VOLVER A TOURS</button>
                                </Link>
                            </div>


                        </div>


                        <div>

                            <br></br>
                            <br></br>
                            <h2 className='camping-letters' style={{ textAlign: "center" }}>ITINERARIO</h2>
                            <div className='text-justify preserve-whitespace' dangerouslySetInnerHTML={{ __html: tour.description }}></div>
                            <h2 className='camping-letters' style={{ textAlign: "center" }}><b>INCLUYE:</b></h2>
                            <div className='text-justify preserve-whitespace' dangerouslySetInnerHTML={{ __html: tour.include }}></div>

                        </div>





                    </div>


                ))}

                {tour.length > 0 && (
                    <div
                        className="d-block d-md-none position-fixed bottom-0 start-0 w-100 bg-white shadow border-top"
                        style={{ zIndex: 1100 }}
                    >
                        <div className="d-flex justify-content-between align-items-center px-3 py-2">
                            <div>
                                {/* Precio por persona */}
                                <strong className="d-block">
                                    ${travelers >= 4 ? tour[0].group_cost : tour[0].person_cost} USD
                                </strong>

                                {/* Texto de referencia */}
                                <small className="text-muted" style={{ fontWeight: '600' }}>
                                    Por persona para {travelers} viajero{travelers > 1 ? 's' : ''}
                                </small>

                                {/* Contador de viajeros */}
                                <div className="d-flex align-items-center mt-1">
                                    <button
                                        className="btn btn-outline-secondary btn-sm me-2"
                                        onClick={() => setTravelers(Math.max(1, travelers - 1))}
                                    >
                                        -
                                    </button>
                                    <strong>{travelers}</strong>
                                    <button
                                        className="btn btn-outline-secondary btn-sm ms-2"
                                        onClick={() => setTravelers(travelers + 1)}
                                    >
                                        +
                                    </button>
                                </div>

                                {/* Total en tiempo real */}
                                <div className="mt-2">
                                    <small className="fw-bold text-success">
                                        Total: ${travelers * (travelers >= 4 ? tour[0].group_cost : tour[0].person_cost)}
                                    </small>
                                </div>
                            </div>

                            {/* Botón de WhatsApp */}
                            <a
                                href={`https://api.whatsapp.com/send?phone=+593${tour[0].contact_phone}&text=${encodeURIComponent(
                                    `👋 ¡Hola! Me gustaría reservar *${travelers} cupo${travelers > 1 ? 's' : ''}* para el tour a *${tour[0].tour_destiny}* 🥾🏔️\n\n*Fecha de salida:* ${tour[0].departure_date}.\n*Costo total del Tour:* $${(travelers >= 4 ? tour[0].group_cost : tour[0].person_cost) * travelers} \n*Valor para reservar el tour:* $${((travelers >= 4 ? tour[0].group_cost : tour[0].person_cost) * travelers)/2} \n\n¿Podrías confirmarme si la información es correcta? ¡Gracias! 🙌`
                                )}`}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <button className="btn btn-success">Reservar Tour</button>
                            </a>
                        </div>
                    </div>
                )}
            </div>




            <br></br>
            <br></br>
            <br></br>
            <WhatsappButtonScreen />
            <FooterScreen />


        </>
    )
}
